export { isMagazineTemplate as isMagazine } from "../../templates/publicationTemplateCatalog.js";
const key = value => String(value || "").trim().toLowerCase();
export const subcategoryNames = value => [...new Set(String(value || "").split(",").map(part => part.trim()).filter(Boolean))];

// The existing schema has one category relation and a legacy comma-separated child-name field.
export function magazineTaxonomySelection(article, categories) {
  const category = categories.find(row => row.id === article?.categoryId)
    || categories.find(row => row.id === article?.category || row.name === (article?.category?.name || article?.category));
  if (!category) return { category: article?.category?.name || article?.category || "", subCategory: article?.subCategory || "" };
  const parent = category.parentId ? categories.find(row => row.id === category.parentId) : category;
  if (!parent) return { category: category.name, subCategory: article?.subCategory || "" };
  const names = subcategoryNames(article?.subCategory);
  if (category.parentId && !names.some(name => key(name) === key(category.name))) names.unshift(category.name);
  return { category: parent.name, subCategory: names.join(",") };
}

export function magazineTaxonomyMutation(input, categories, publicationId) {
  const owned = categories.filter(row => row.publicationId === publicationId && !row.deletedAt);
  const selected = input.categoryId ? owned.filter(row => row.id === input.categoryId) : owned.filter(row => row.name === input.category);
  if (selected.length !== 1) throw new Error("Select an existing category from this publication.");
  const category = selected[0];
  const parent = category.parentId ? owned.find(row => row.id === category.parentId && !row.parentId) : category;
  if (!parent) throw new Error("Select a category with a valid main category.");
  const children = owned.filter(row => row.parentId === parent.id);
  if (subcategoryNames(input.subCategory).some(name => !children.some(child => key(child.name) === key(name) || child.id === name || key(child.slug) === key(name)))) {
    throw new Error("This article has a subcategory that is no longer configured. Review its category selection before saving.");
  }
  const requested = Array.isArray(input.subcategoryIds)
    ? input.subcategoryIds.map(id => { const child = children.find(row => row.id === id); if (!child) throw new Error("Select subcategories belonging to the selected main category."); return child.name; })
    : subcategoryNames(input.subCategory);
  if (category.parentId) requested.push(category.name);
  const canonical = [...new Set(requested.map(name => {
    const child = children.find(row => key(row.name) === key(name) || row.id === name || key(row.slug) === key(name));
    if (!child) throw new Error("Select subcategories belonging to the selected main category.");
    return child.name;
  }))];
  return { categoryId: parent.id, subCategory: canonical.join(",") || null };
}

export function categoryFamily(categories, categoryId) {
  const ids = new Set([categoryId]);
  for (let previous = -1; previous !== ids.size;) {
    previous = ids.size;
    categories.forEach(row => { if (ids.has(row.parentId)) ids.add(row.id); });
  }
  return [...ids];
}

export function magazineArticleMatchesCategory(article, category, categories) {
  if (!category) return false;
  if (categoryFamily(categories, category.id).includes(article.categoryId)) return true;
  return Boolean(category.parentId && article.categoryId === category.parentId
    && subcategoryNames(article.subCategory).some(name => [category.name, category.slug, category.id].some(value => key(value) === key(name))));
}

// Comma boundaries, not substrings: Crime must never match Cybercrime.
export function taxonomyTokenPattern(values) {
  return `(^|,)[[:space:]]*(${values.map(value => key(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})[[:space:]]*(,|$)`;
}
